module.exports = __webpack_public_path__ + "images/logo-header.svg";